import { Link } from 'react-router-dom'

export default function Terminos() {
  return (
    <div style={S.page}>
      <div style={S.inner}>
        <div style={S.backRow}>
          <Link to="/" style={S.back}>← Volver al inicio</Link>
        </div>

        <h1 style={S.h1}>Términos y Condiciones de Uso</h1>
        <p style={S.meta}>Última actualización: mayo 2026 · Qapaq SpA · RUT 78.415.721-0</p>

        <Section title="1. Objeto y aceptación">
          <p>Estos Términos y Condiciones («T&C») regulan el acceso y uso de la plataforma digital Qapaq,
          operada por Qapaq SpA (RUT 78.415.721-0), con domicilio en Hijuelas, V Región de Valparaíso, Chile
          («Qapaq» o «la Empresa»).</p>
          <p>Al registrarse o usar la plataforma, el usuario acepta íntegramente estos T&C. Si no está de acuerdo,
          debe abstenerse de usar el servicio.</p>
        </Section>

        <Section title="2. Rol de Qapaq — intermediario logístico">
          <p>Qapaq actúa exclusivamente como plataforma de intermediación entre oferentes de carga («Oferentes»)
          y transportistas («Transportistas»). Qapaq no es parte del contrato de transporte celebrado entre ambos,
          salvo en los casos en que opere con flota propia.</p>
          <p>Los Transportistas son prestadores independientes y no empleados ni agentes de Qapaq.</p>
        </Section>

        <Section title="3. Seguro de carga y procedimiento ante siniestros">
          <p>Qapaq contrata un seguro de carga flotante con <strong>cobertura máxima de 4.000 UF
          (cuatro mil Unidades de Fomento) por evento</strong>, que ampara pérdida parcial o total
          de la mercancía por accidente, robo o hurto.</p>
          <p>Ante cualquier siniestro reportado en la Plataforma, Qapaq actuará como canal de denuncia
          ante la compañía aseguradora y pondrá a disposición de esta la información y documentación
          disponible. <strong>Qapaq no garantiza ni asegura el pago de indemnización alguna</strong>:
          la procedencia, monto y condiciones de cualquier restitución son determinados exclusiva y
          soberanamente por la aseguradora conforme a su póliza, sus exclusiones y su evaluación del
          siniestro. Qapaq no es parte del contrato de seguro y no asume obligaciones de pago propias
          derivadas de él.</p>
          <Alerta>
            Qapaq no dispone de cobertura aseguradora para cargas cuyo valor supere las 4.000 UF.
            Para dichos casos, Qapaq no puede canalizar el siniestro ante la aseguradora por el exceso,
            ni responde por perjuicio alguno sobre el monto que exceda dicho límite.
          </Alerta>
          <p>El Oferente que transporte bienes por un valor superior a 4.000 UF deberá:</p>
          <ol>
            <li>Declarar el valor real de la carga al momento de publicar el requerimiento.</li>
            <li>Contratar por su cuenta un seguro de transporte complementario que cubra el exceso.</li>
            <li>Informar al Transportista asignado sobre la naturaleza y valor de la mercancía previo al retiro.</li>
          </ol>
        </Section>

        <Section title="4. Obligaciones del Oferente">
          <ul>
            <li>Declarar correctamente el tipo, peso, dimensiones y valor de la carga.</li>
            <li>Embalar la mercancía de forma adecuada para el transporte terrestre.</li>
            <li>Asegurarse de que la carga no contenga materiales peligrosos, ilícitos o restringidos.</li>
            <li>Estar disponible para coordinar la carga y descarga en los horarios acordados.</li>
            <li>Pagar el precio acordado dentro de los plazos establecidos en la plataforma.</li>
          </ul>
        </Section>

        <Section title="5. Obligaciones del Transportista">
          <ul>
            <li>Mantener vigentes su licencia de conducir, permisos de circulación y revisión técnica.</li>
            <li>Declarar con exactitud las características de su vehículo y capacidad de carga.</li>
            <li>Cumplir los horarios y rutas comprometidos en la oferta aceptada.</li>
            <li>Tratar la carga con el cuidado propio de un transportista diligente.</li>
            <li>Informar de inmediato a Qapaq ante cualquier incidente, accidente o retraso significativo.</li>
          </ul>
        </Section>

        <Section title="6. Precios, comisiones y facturación">
          <p>Todos los precios publicados en la plataforma corresponden a valores <strong>neto, sin IVA</strong>.
          El IVA (19%) se agrega al momento de la emisión del documento tributario electrónico (DTE)
          conforme a la normativa del Servicio de Impuestos Internos (SII).</p>
          <p>Qapaq cobra una comisión por intermediación sobre cada envío concretado. El porcentaje
          vigente se informa en la sección «Servicios» de la plataforma y puede actualizarse con
          aviso previo de 15 días.</p>
        </Section>

        <Section title="7. Documentos tributarios electrónicos (DTE)">
          <p>Qapaq emite los DTE correspondientes a cada operación de acuerdo con la normativa SII vigente.
          El Oferente recibirá la Factura Electrónica (tipo 33) por el monto total del servicio (neto + IVA).
          El Transportista recibirá el documento tributario que corresponda según su situación fiscal.</p>
        </Section>

        <Section title="8. Responsabilidad limitada">
          <p>Sin perjuicio de lo dispuesto en la cláusula 3, la responsabilidad total de Qapaq
          frente a cualquier usuario, por cualquier concepto, no excederá el monto de las
          comisiones efectivamente pagadas por ese usuario en los 3 meses anteriores al hecho
          que origina el reclamo.</p>
          <p>Qapaq no será responsable por daños indirectos, lucro cesante, daño emergente no
          directamente relacionado con la operación de la plataforma, ni por fallas atribuibles
          a terceros (Internet, proveedores de pago, etc.).</p>
        </Section>

        <Section title="9. Suspensión y término de cuenta">
          <p>Qapaq podrá suspender o dar de baja una cuenta en caso de incumplimiento de estos T&C,
          conducta fraudulenta, declaraciones falsas o comportamiento que afecte a otros usuarios,
          sin perjuicio de las acciones legales que procedan.</p>
        </Section>

        <Section title="10. Modificaciones">
          <p>Qapaq podrá modificar estos T&C en cualquier momento, notificando a los usuarios
          registrados con al menos 15 días de anticipación mediante correo electrónico o aviso
          en la plataforma. El uso continuado del servicio tras ese plazo constituye aceptación
          de los cambios.</p>
        </Section>

        <Section title="11. Ley aplicable y jurisdicción">
          <p>Estos T&C se rigen por las leyes de la República de Chile. Para cualquier controversia
          las partes se someten a la jurisdicción de los Tribunales de Justicia de la ciudad de
          Valparaíso, renunciando a cualquier otro fuero.</p>
        </Section>

        <div style={S.contacto}>
          {/* 0.16 — Acá se publicaba «+56 9 1234 5678» con enlace wa.me activo:
              un número de relleno, en vivo, en la página donde alguien busca
              cómo contactar formalmente a la empresa. Quien lo pulsara terminaba
              escribiéndole a un desconocido creyendo que hablaba con QAPAQ.
              Se retira hasta que el número de Business esté operativo — hoy ese
              canal además no tiene a nadie detrás (ver 13.9). */}
          <p>Consultas: <a href="mailto:contacto@qapaq.cl">contacto@qapaq.cl</a></p>
        </div>
      </div>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <section style={S.section}>
      <h2 style={S.h2}>{title}</h2>
      <div style={S.body}>{children}</div>
    </section>
  )
}

function Alerta({ children }) {
  return (
    <div style={S.alerta}>
      ⚠️ <span>{children}</span>
    </div>
  )
}

const S = {
  page: {
    minHeight: '100vh',
    background: '#F9F9F9',
    padding: '2rem 1rem 4rem',
    fontFamily: "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
  },
  inner: {
    maxWidth: 780,
    margin: '0 auto',
  },
  backRow: {
    marginBottom: '1.5rem',
  },
  back: {
    color: '#FF5A00',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 600,
  },
  h1: {
    fontSize: 'clamp(1.5rem, 3vw, 2rem)',
    fontWeight: 800,
    color: '#111111',
    margin: '0 0 0.5rem',
  },
  meta: {
    fontSize: '0.82rem',
    color: '#888',
    marginBottom: '2.5rem',
  },
  section: {
    marginBottom: '2rem',
    borderBottom: '1px solid #E8E8E8',
    paddingBottom: '1.5rem',
  },
  h2: {
    fontSize: '1rem',
    fontWeight: 700,
    color: '#FF5A00',
    marginBottom: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
  },
  body: {
    fontSize: '0.92rem',
    color: '#333',
    lineHeight: 1.7,
  },
  alerta: {
    background: '#FFF3E5',
    border: '1.5px solid #FF5A00',
    borderRadius: 8,
    padding: '0.9rem 1.1rem',
    margin: '1rem 0',
    fontSize: '0.92rem',
    color: '#111',
    fontWeight: 600,
    lineHeight: 1.6,
    display: 'flex',
    gap: '0.5rem',
  },
  contacto: {
    marginTop: '2.5rem',
    fontSize: '0.88rem',
    color: '#555',
    textAlign: 'center',
  },
}
